(function () {
  const STORAGE_KEY = 'tgd_quote_list';
  const MINIMUM_QUANTITY = 10;

  function isSpanish() {
    const lang = document.documentElement.lang || '';
    return lang.toLowerCase().startsWith('es');
  }

  function getQuoteList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  function saveQuoteList(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateQuoteCount();
    updateHiddenQuoteBody();
  }

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function cleanColorValue(value) {
    const cleaned = cleanText(value)
      .replace(/^color[:\s]*/i, '')
      .replace(/^colour[:\s]*/i, '')
      .trim();

    const lower = cleaned.toLowerCase();

    if (!cleaned) return '';
    if (cleaned === 'Default Title') return '';
    if (lower === 'quantity') return '';
    if (lower === 'notes') return '';
    if (lower.includes('minimum order')) return '';
    if (lower.includes('minimum 10')) return '';
    if (lower.includes('add to quote')) return '';
    if (lower.includes('added to quote')) return '';
    if (lower.includes('available for custom')) return '';
    if (lower.includes('product details')) return '';
    if (lower.includes('sizing')) return '';
    if (lower === 'info') return '';

    return cleaned;
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = String(value || '');
    return div.innerHTML;
  }

  function isQuantityBelowMinimum(value) {
    if (value === '') return false;

    const number = Number(value);

    if (!Number.isFinite(number)) return false;

    return number < MINIMUM_QUANTITY;
  }

  function validateQuoteQuantityInput(input) {
    const field = input.closest('.tgd-quote-item__field');
    const help = field ? field.querySelector('[data-tgd-quote-quantity-help]') : null;
    const isInvalid = isQuantityBelowMinimum(input.value);

    input.classList.toggle('is-invalid', isInvalid);

    if (help) {
      help.hidden = !isInvalid;
    }

    return !isInvalid;
  }

  function getCurrentProductSelection(button) {
    const productInfo = button.closest('product-info') || document;

    let selectedVariantId = button.dataset.selectedVariantId || '';
    let selectedVariantTitle = '';
    let selectedColor = '';
    let selectedColorCode = '';

    const currentVariantInput = productInfo.querySelector('input[name="id"]');

    if (currentVariantInput && currentVariantInput.value) {
      selectedVariantId = currentVariantInput.value;
    }

    const productInfoColorName =
      productInfo.getAttribute && productInfo.getAttribute('data-tgd-selected-color-name')
        ? productInfo.getAttribute('data-tgd-selected-color-name')
        : '';

    const productInfoColorCode =
      productInfo.getAttribute && productInfo.getAttribute('data-tgd-selected-color-code')
        ? productInfo.getAttribute('data-tgd-selected-color-code')
        : '';

    const bodyColorName = document.body.getAttribute('data-tgd-selected-color-name') || '';
    const bodyColorCode = document.body.getAttribute('data-tgd-selected-color-code') || '';

    selectedColor = cleanColorValue(productInfoColorName) || cleanColorValue(bodyColorName);
    selectedColorCode = cleanText(productInfoColorCode) || cleanText(bodyColorCode);

    const tgdColorNameInput = document.getElementById('tgd-selected-color-name');
    const tgdColorCodeInput = document.getElementById('tgd-selected-color-code');
    const tgdColorInput = document.getElementById('tgd-selected-color');
    const tgdSelectedText = document.getElementById('tgd-color-selected-text');
    const selectedSwatch = document.querySelector('.tgd-color-swatch.is-selected');

    if (!selectedColor && tgdColorNameInput) {
      selectedColor = cleanColorValue(tgdColorNameInput.value);
    }

    if (!selectedColor && tgdColorInput) {
      selectedColor = cleanColorValue(tgdColorInput.value);
    }

    if (!selectedColor && tgdSelectedText) {
      selectedColor = cleanColorValue(tgdSelectedText.textContent);
    }

    if (!selectedColor && selectedSwatch) {
      selectedColor = cleanColorValue(
        selectedSwatch.getAttribute('data-color-name') ||
          selectedSwatch.getAttribute('aria-label') ||
          ''
      );
    }

    if (!selectedColorCode && tgdColorCodeInput) {
      selectedColorCode = cleanText(tgdColorCodeInput.value);
    }

    if (!selectedColorCode && selectedSwatch) {
      selectedColorCode = cleanText(selectedSwatch.getAttribute('data-color-code') || '');
    }

    selectedVariantTitle = selectedColor || '';

    return {
      selectedVariantId,
      selectedVariantTitle,
      selectedColor,
      selectedColorCode
    };
  }

  function normalizeItemFromButton(button) {
    const currentSelection = getCurrentProductSelection(button);

    return {
      productId: button.dataset.productId || '',
      productHandle: button.dataset.productHandle || '',
      productUrl: button.dataset.productUrl || '',
      productTitle: button.dataset.productTitle || '',
      productRef: button.dataset.productRef || '',
      productImage: button.dataset.productImage || '',
      selectedVariantId: currentSelection.selectedVariantId || '',
      selectedVariantTitle: currentSelection.selectedVariantTitle || '',
      selectedColor: currentSelection.selectedColor || currentSelection.selectedVariantTitle || '',
      selectedColorCode: currentSelection.selectedColorCode || '',
      quantity: '',
      notes: '',
      addedAt: new Date().toISOString()
    };
  }

  function showQuoteAddedMessage(item) {
    let message = document.querySelector('[data-tgd-quote-added-message]');

    if (!message) {
      message = document.createElement('div');
      message.className = 'tgd-quote-added-message';
      message.setAttribute('data-tgd-quote-added-message', 'true');

      message.innerHTML = `
        <div class="tgd-quote-added-message__inner">
          <div class="tgd-quote-added-message__content">
            <p class="tgd-quote-added-message__eyebrow"></p>
            <p class="tgd-quote-added-message__text"></p>
          </div>

          <a href="/pages/quote-list" class="tgd-quote-added-message__button"></a>
        </div>
      `;

      document.body.prepend(message);
    }

    const eyebrow = message.querySelector('.tgd-quote-added-message__eyebrow');
    const text = message.querySelector('.tgd-quote-added-message__text');
    const button = message.querySelector('.tgd-quote-added-message__button');

    const productName = item && item.productTitle ? item.productTitle : '';
    const colorName = item && item.selectedColor ? item.selectedColor : '';

    if (eyebrow) {
      eyebrow.textContent = isSpanish() ? 'Producto añadido' : 'Product added';
    }

    if (text) {
      text.textContent = isSpanish()
        ? `${productName}${colorName ? ' — ' + colorName : ''} se ha añadido a tu lista de presupuesto.`
        : `${productName}${colorName ? ' — ' + colorName : ''} has been added to your quote list.`;
    }

    if (button) {
      button.textContent = isSpanish() ? 'Ver lista de presupuesto' : 'View quote list';
    }

    message.classList.add('is-visible');

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  function addItem(button) {
    const newItem = normalizeItemFromButton(button);
    const items = getQuoteList();

    const existingIndex = items.findIndex((item) => {
      if (item.productId !== newItem.productId) return false;

      if (newItem.selectedColorCode) {
        return item.selectedColorCode === newItem.selectedColorCode;
      }

      if (newItem.selectedColor) {
        return item.selectedColor === newItem.selectedColor;
      }

      return item.selectedVariantId === newItem.selectedVariantId;
    });

    if (existingIndex >= 0) {
      items[existingIndex] = {
        ...items[existingIndex],
        ...newItem,
        quantity: items[existingIndex].quantity || '',
        notes: items[existingIndex].notes || '',
        addedAt: items[existingIndex].addedAt || newItem.addedAt
      };
    } else {
      items.push(newItem);
    }

    saveQuoteList(items);

    button.textContent = isSpanish() ? 'Añadido a la lista' : 'Added to quote list';
    button.classList.add('is-added');

    const viewLink = document.querySelector('[data-tgd-quote-view-link]');

    if (viewLink) {
      viewLink.hidden = false;
      viewLink.textContent = isSpanish() ? 'Ver lista de presupuesto' : 'View quote list';
    }

    showQuoteAddedMessage(newItem);

    console.log('[TGD Quote List] Product added:', newItem);
  }

  function updateQuoteCount() {
    const items = getQuoteList();

    document.querySelectorAll('[data-tgd-quote-count]').forEach((element) => {
      element.textContent = items.length;
      element.hidden = items.length === 0;
    });
  }

  function renderQuoteListPage() {
    const container = document.querySelector('[data-tgd-quote-list]');
    if (!container) return;

    const empty = document.querySelector('[data-tgd-quote-empty]');
    const formWrapper = document.querySelector('[data-tgd-quote-form-wrapper]');
    const items = getQuoteList();

    container.querySelectorAll('.tgd-quote-item').forEach((node) => node.remove());

    if (empty) {
      empty.hidden = items.length > 0;
    }

    if (formWrapper) {
      formWrapper.hidden = items.length === 0;
    }

    items.forEach((item, index) => {
      const colorLabel = item.selectedColor || item.selectedVariantTitle || '—';
      const quantityIsInvalid = isQuantityBelowMinimum(item.quantity || '');

      const article = document.createElement('article');
      article.className = 'tgd-quote-item';
      article.dataset.index = String(index);

      article.innerHTML = `
        ${
          item.productImage
            ? `<img class="tgd-quote-item__image" src="${escapeHtml(item.productImage)}" alt="">`
            : `<div class="tgd-quote-item__image"></div>`
        }

        <div class="tgd-quote-item__content">
          <h2 class="tgd-quote-item__title">${escapeHtml(item.productTitle || 'Product')}</h2>
          <p class="tgd-quote-item__meta">REF: ${escapeHtml(item.productRef || '—')}</p>
          <p class="tgd-quote-item__meta">Color: ${escapeHtml(colorLabel)}</p>

          <div class="tgd-quote-item__fields">
            <div class="tgd-quote-item__field">
              <label>Quantity</label>
              <input
                type="number"
                step="1"
                inputmode="numeric"
                placeholder="Minimum 10 units"
                value="${escapeHtml(item.quantity || '')}"
                class="${quantityIsInvalid ? 'is-invalid' : ''}"
                data-tgd-quote-quantity
                data-index="${index}"
              >
              <p class="tgd-quote-item__help" data-tgd-quote-quantity-help ${quantityIsInvalid ? '' : 'hidden'}>
                Minimum order quantity: 10 units
              </p>
            </div>

            <div class="tgd-quote-item__field">
              <label>Notes</label>
              <textarea rows="2" data-tgd-quote-notes data-index="${index}">${escapeHtml(item.notes || '')}</textarea>
            </div>
          </div>
        </div>

        <button type="button" class="tgd-quote-item__remove" data-tgd-quote-remove data-index="${index}">
          Remove
        </button>
      `;

      container.appendChild(article);
    });

    updateHiddenQuoteBody();
  }

  function updateQuoteItem(index, patch) {
    const items = getQuoteList();
    if (!items[index]) return;

    items[index] = {
      ...items[index],
      ...patch
    };

    saveQuoteList(items);
  }

  function removeQuoteItem(index) {
    const items = getQuoteList();
    items.splice(index, 1);
    saveQuoteList(items);
    renderQuoteListPage();
  }

  function updateHiddenQuoteBody() {
    const field = document.querySelector('[data-tgd-quote-hidden-body]');
    if (!field) return;

    const items = getQuoteList();

    const lines = [
  ...items.flatMap((item, index) => [
    `— PRODUCT ${index + 1} —`,
    `Name: ${item.productTitle || ''}`,
    `REF: ${item.productRef || ''}`,
    `Color: ${item.selectedColor || item.selectedVariantTitle || ''}`,
    `Quantity: ${item.quantity || ''}`,
    `Notes: ${item.notes || ''}`,
    ''
  ])
];

    field.value = lines.join('\n');
  }

  document.addEventListener('click', function (event) {
    const addButton = event.target.closest('[data-tgd-quote-add]');

    if (addButton) {
      event.preventDefault();
      addItem(addButton);
      return;
    }

    const removeButton = event.target.closest('[data-tgd-quote-remove]');

    if (removeButton) {
      event.preventDefault();
      removeQuoteItem(Number(removeButton.dataset.index));
    }
  });

  document.addEventListener('input', function (event) {
    const quantityInput = event.target.closest('[data-tgd-quote-quantity]');

    if (quantityInput) {
      validateQuoteQuantityInput(quantityInput);

      updateQuoteItem(Number(quantityInput.dataset.index), {
        quantity: quantityInput.value
      });

      return;
    }

    const notesInput = event.target.closest('[data-tgd-quote-notes]');

    if (notesInput) {
      updateQuoteItem(Number(notesInput.dataset.index), {
        notes: notesInput.value
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
  updateQuoteCount();

  const quoteSuccessMessage = document.querySelector('[data-tgd-quote-success]');
  const quoteRequestWasSent = new URLSearchParams(window.location.search).has('contact_posted');

  if (quoteSuccessMessage && quoteRequestWasSent) {
    localStorage.removeItem(STORAGE_KEY);

   const quoteList = document.querySelector('[data-tgd-quote-list]');
const quoteEmptyMessage = document.querySelector('[data-tgd-quote-empty]');
const quoteFormWrapper = document.querySelector('[data-tgd-quote-form-wrapper]');

if (quoteList) quoteList.hidden = true;
if (quoteEmptyMessage) quoteEmptyMessage.hidden = true;
if (quoteFormWrapper) quoteFormWrapper.hidden = true;

    quoteSuccessMessage.hidden = false;

    updateQuoteCount();

    quoteSuccessMessage.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    console.log('[TGD Quote List] Quote request sent');
    return;
  }

  renderQuoteListPage();
  updateHiddenQuoteBody();

  console.log('[TGD Quote List] JS loaded');
});
})();